<template>
  <div>
    <a-modal
      :title="`剪裁图片`"
      centered
      :width="850"
      :mask-closable="false"
      :visible="showCropper"
      :confirmLoading="loading"
      @cancel="handleCancel"
      :footer="null"
    >

    <a-spin :tip="'loading...' " size="large" :spinning="loading">
    <div class="wrapper">
 
      <div class="content">
   
        <div class="show-info">
          <div class="test" v-if="!showImg">
            <vueCropper
                ref="cropper"
                :img="option.img"
                :info="option.info"
                :canScale="option.canScale"
                :autoCrop="option.autoCrop"
                :autoCropWidth="option.autoCropWidth"
                :autoCropHeight="option.autoCropHeight"
                :fixedBox="option.fixedBox"
                :fixed="option.fixed"
                :fixedNumber="option.fixedNumber"
                :canMove="option.canMove"
                :canMoveBox="option.canMoveBox"
                :original="option.original"
                :centerBox="option.centerBox"
                :infoTrue="option.infoTrue"
                :full="option.full"
                :enlarge="option.enlarge"
                :mode="option.mode"
                :outputSize="1"
                :high="true"
                @realTime="realTime"
            ></vueCropper>
          </div>

          <div class="model-show" v-else>
            <img :src="modelSrc" alt="" >
          </div>

          <template v-if="option.autoCrop">
            图片比例：
            <a-button :type="fixedType === 0 ? 'danger' : 'primary'" @click="changeFixed(0)" class="btn">自由截图</a-button>
            <a-button :type="fixedType === 1 ? 'danger' : 'primary'" @click="changeFixed(1)" class="btn">固定比例1:1</a-button>
            <a-button :type="fixedType === 2 ? 'danger' : 'primary'" @click="changeFixed(2)" class="btn">固定比例2:1</a-button>
            <a-button :type="fixedType === 3 ? 'danger' : 'primary'"  @click="changeFixed(3)" class="btn">固定比例3:5</a-button>
            <br>
            操&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;作：
            <a-button  @click="changeScale(1)" class="btn">放大 +</a-button>
            <a-button  @click="changeScale(-1)" class="btn">缩小 -</a-button>
            <br>
            操作图片：
            <a-button type="danger" v-if="option.autoCrop" @click="finish()" class="btn">裁剪</a-button>
          </template>
       
          <div v-else style="text-align:center">
            <a-button type="primary" @click="downLoad()" class="btn">下载素材</a-button>
            <a-tag type="primary" @click="uploadImg()" class="btn" color="red">确定并上传素材</a-tag>
          </div>
        </div>
      </div>
   
    </div>

    </a-spin>

     
    </a-modal>
  </div>
</template>

<style lang="less" scoped>
@import 'Cropper';
</style>

<script>
import Cropper from './Cropper'
export default Cropper
</script>